import { call, put, takeEvery } from "redux-saga/effects";

import { PaginateQuery, ResponseGenerator } from "../../interfaces";
import {
  AddGradeAction,
  DeleteGradeAction,
  GET_GRADES_DETAIL_BY_COURSE,
  GET_GRADE_SELECT_LIST_BY_COURSE,
  GET_GRADE_SELECT_LIST_BY_COURSE_LOCAL,
  GetGradeAction,
  GetGradeSelectListByCourseAction,
  GetGradeSelectListByCourseLocalAction,
  GetGradesAction,
  GetGradesDetailByCourseAction,
  UpdateGradeAction,
} from "./actionTypes";

import {
  addGrade,
  deleteGrade,
  getGrade,
  getGradeSelectListByCourse,
  getGrades,
  getGradesDetailByCourse,
  updateGrade,
} from "../../helpers/backend_helper";
import {
  addGradeError,
  addGradeSuccess,
  deleteGradeError,
  deleteGradeSuccess,
  getGradeError,
  getGradeSelectListByCourseError,
  getGradeSelectListByCourseLocalError,
  getGradeSelectListByCourseLocalSuccess,
  getGradeSelectListByCourseSuccess,
  getGradeSuccess,
  getGradesDetailByCourseError,
  getGradesDetailByCourseSuccess,
  getGradesError,
  getGradesSuccess,
  updateGradeError,
  updateGradeSuccess,
} from "./actions";
import {
  GET_GRADES,
  GET_GRADE,
  ADD_GRADE,
  UPDATE_GRADE,
  DELETE_GRADE,
} from "../grade/actionTypes";

function* getGradesSaga({ payload: { request, history } }: GetGradesAction) {
  try {
    const response: ResponseGenerator = yield call(
      getGrades,
      request as PaginateQuery
    );
    yield put(getGradesSuccess(response.data));
  } catch (error) {
    yield put(getGradesError(error));
  }
}

function* getGradeSaga({ payload: { id, history } }: GetGradeAction) {
  try {
    const response: ResponseGenerator = yield call(getGrade, id);
    yield put(getGradeSuccess(response.data));
  } catch (error) {
    yield put(getGradeError(error));
  }
}

function* getGradeSelectListByCourseSaga({
  payload: { courseId },
}: GetGradeSelectListByCourseAction) {
  try {
    const response: ResponseGenerator = yield call(
      getGradeSelectListByCourse,
      courseId
    );
    yield put(getGradeSelectListByCourseSuccess(response.data));
  } catch (error) {
    yield put(getGradeSelectListByCourseError(error));
  }
}

function* getGradesDetailByCourseSaga({
  payload: { courseId },
}: GetGradesDetailByCourseAction) {
  try {
    const response: ResponseGenerator = yield call(
      getGradesDetailByCourse,
      courseId
    );
    yield put(getGradesDetailByCourseSuccess(response.data));
  } catch (error) {
    yield put(getGradesDetailByCourseError(error));
  }
}

function* addGradeSaga({ payload: { request, history } }: AddGradeAction) {
  try {
    yield call(addGrade, request);
    yield put(addGradeSuccess());
  } catch (error) {
    yield put(addGradeError(error));
  }
}

function* updateGradeSaga({
  payload: { id, request, history },
}: UpdateGradeAction) {
  try {
    yield call(updateGrade, id, request);
    yield put(updateGradeSuccess());
  } catch (error) {
    yield put(updateGradeError(error));
  }
}

function* deleteGradeSaga({ payload: { id, history } }: DeleteGradeAction) {
  try {
    yield call(deleteGrade, id);
    yield put(deleteGradeSuccess());
  } catch (error) {
    yield put(deleteGradeError(error));
  }
}

function* getGradeSelectListByCourseLocalSaga({
  payload: { courseId },
}: GetGradeSelectListByCourseLocalAction) {
  try {
    const response: ResponseGenerator = yield call(
      getGradeSelectListByCourse,
      courseId
    );
    yield put(getGradeSelectListByCourseLocalSuccess(response.data));
  } catch (error) {
    yield put(getGradeSelectListByCourseLocalError(error));
  }
}

function* GradeSage() {
  yield takeEvery(
    GET_GRADE_SELECT_LIST_BY_COURSE,
    getGradeSelectListByCourseSaga
  );
  yield takeEvery(GET_GRADES, getGradesSaga);
  yield takeEvery(GET_GRADE, getGradeSaga);
  yield takeEvery(ADD_GRADE, addGradeSaga);
  yield takeEvery(UPDATE_GRADE, updateGradeSaga);
  yield takeEvery(DELETE_GRADE, deleteGradeSaga);
  yield takeEvery(GET_GRADES_DETAIL_BY_COURSE, getGradesDetailByCourseSaga);
  yield takeEvery(
    GET_GRADE_SELECT_LIST_BY_COURSE_LOCAL,
    getGradeSelectListByCourseLocalSaga
  );
}

export default GradeSage;
